
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vybeful-pro",
      function () {
        return require("private-next-pages/vybeful-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vybeful-pro"])
      });
    }
  